import { Directive, Input } from '@angular/core';
import { FacetItem, SearchItem } from '@aipb/gulliver/catalog/model';

@Directive()
export class FacetBaseComponent<T = unknown> {
  @Input() searchItem: SearchItem;
  @Input() facetItem: FacetItem;
  @Input() settings: T;
}
